module.exports = __webpack_public_path__ + "img/body.932f91a5.png";